module.exports = __webpack_public_path__ + "img/s1.b7257af4.jpg";